import { setCities } from '../../actions';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = [];

export default createReducer(
  [forAction(setCities, identityPayload)],
  initialState,
);
